export const BLOCK_RECEIVED = 'BLOCK_RECEIVED';
export const ACCOUNTS_CHANGED = 'ACCOUNTS_CHANGED';
export const ACCOUNTS_RECOVERED = 'ACCOUNTS_RECOVERED';
export const LOGIN_INITIALIZED = 'LOGIN_INITIALIZED';
export const LOGIN_TRIED = 'LOGIN_TRIED';
export const LOGIN_INITPAGE = 'LOGIN_INITPAGE';
export const SIGNUP_GRANTING = 'SIGNUP_GRANTING';
export const SIGNUP_GRANTED = 'SIGNUP_GRANTED';
export const SIGNUP_WILL_COMMIT = 'SIGNUP_WILL_COMMIT';
export const SIGNUP_COMMITTING = 'SIGNUP_COMMITTING';
export const SIGNUP_COMMITTED = 'SIGNUP_COMMITTED';
export const SIGNUP_COMMIT_COMPLETE = 'SIGNUP_COMMIT_COMPLETE';
export const SIGNUP_CONFIGURATION_COMPLETE = 'SIGNUP_CONFIGURATION_COMPLETE';
export const PATHNAME_CHANGED = 'PATHNAME_CHANGED';
